import React from 'react';
import { ProfileQL } from '../../models/Profile';
import { Link } from 'react-router-dom';
import moment from 'moment';

import './titlebar.scss';

function getTitlebarNotice(currentUser: ProfileQL): { link: string, message: string } | null {
    if(!currentUser) return null;
    const fpStatus = !!currentUser.fiscalpopProfileStatus ? currentUser.fiscalpopProfileStatus : null;
    const billStatus = currentUser.billing ? currentUser.billing : null;

    if (!fpStatus) return null; // No status, not started yet

    // BILLING CASES FIRST
    // --------------------------------------
    if (billStatus?.hasStripeSubscription && billStatus?.stripeSubscriptionMaxedOut) {
        return {
            link: '/account',
            message: `Su cuenta ha alcanzado el límite de su plan actual. De click aquí para más información.`,
        };
    }

    if (billStatus.hasStripeSubscription && billStatus.stripeSubscriptionStatus === 'past_due') {
        return {
            link: '/account',
            message: `Hubo un problema al procesar el pago de su plan. De click aquí para más información.`,
        };
    }

    if (billStatus?.enabled === false) {
        const disabledWarning = currentUser?.billing?.hasStripeSubscription ?
            `Su cuenta está deshabilitada. Por favor revise su cuenta y plan de facturación`
            : 'Falta saldo en su cuenta, revise su saldo para continuar facturando';
        return {
            link: '/account',
            message: disabledWarning,
        };
    }

    // CONFIGURATION CASES SECOND
    // --------------------------------------

    if (!fpStatus.cerModulus && !fpStatus.keyModulus) {
        const bothWarning = `Necesita subir su llave y certificado CSD para continuar`;
        return {
            link: '/setup?showcerts=true',
            message: bothWarning,
        };
    }

    if (!fpStatus.cerModulus) {
        const certWarning = `Necesita subir su certificado CSD para facturar`;
        return {
            link: '/setup?showcerts=true',
            message: certWarning,
        };
    }

    if (!fpStatus.keyModulus) {
        const keyWarning = `Necesita subir su llave de su CSD para facturar`;
        return {
            link: '/setup?showcerts=true',
            message: keyWarning,
        };
    }

    if (fpStatus.cerModulus && fpStatus.keyModulus && !fpStatus.modulusMatch) {
        const modulusWarning = `Su llave no coincide con su certificado CSD, es necesario agregar los archivos correctos`;
        return {
            link: '/setup?showcerts=true',
            message: modulusWarning,
        };
    }

    if (!!fpStatus.notBefore && (new Date(fpStatus.notBefore).getTime() > Date.now())) {
        const notYetWarning = `El CSD todavia no puede ser usado, espere hasta el ${moment(new Date(fpStatus.notBefore).getTime()).format('dddd, MMMM Do YYYY, h:mm:ss a')}`;
        return {
            link: '/setup?showcerts=true',
            message: notYetWarning,
        };
    }

    if (!!fpStatus.notAfter && (new Date(fpStatus.notAfter).getTime() < Date.now())) {
        const notAnymoreWarning = `El CSD ya no es valido, venció el ${moment(new Date(fpStatus.notAfter).getTime()).format('dddd, MMMM Do YYYY, h:mm:ss a')}`;
        return {
            link: '/setup?showcerts=true',
            message: notAnymoreWarning,
        };
    }

    return null;
}

export function hasTitlebarNotice(currentUser: ProfileQL): boolean {
    return getTitlebarNotice(currentUser) !== null;
}

export function SectionTitlebarNotice({ currentUser }: { currentUser: ProfileQL }) {
    const notice = getTitlebarNotice(currentUser);
    if (!notice) {
        return <div className="__titleMessage _empty"></div>;
    }
    return (
        <div className="__titleMessage">
            <Link to={notice.link}>
                <p>
                    {notice.message}
                </p>
            </Link>
        </div>
    );
}

function SectionTitleBar({ currentUser, title }: { currentUser: ProfileQL, title: string }) {

    return (
        <div className="__titleBar">
            <h3>{title}</h3>

            <SectionTitlebarNotice currentUser={currentUser} />
        </div>
    )
}

export default SectionTitleBar;
